module.exports = __webpack_public_path__ + "img/健康管理@2x.aeeaa9a0.png";